﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class VehicleAssignmentClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    findAssignableVehicleAppIdsByOrganization(organizationAppId) {
        return this.client.apiVehicleassignmentsOrganizationByOrganizationAppIdGet(organizationAppId);
    }
    isVehicleAssignableByOrganization(vehicleAppId, organizationAppId) {
        return this.client.apiVehicleassignmentsVehicleByVehicleAppIdOrganizationByOrganizationAppIdGet(vehicleAppId, organizationAppId);
    }
}
exports.VehicleAssignmentClient = VehicleAssignmentClient;
//# sourceMappingURL=VehicleAssignmentClient.js.map